import {createContext,useContext,type ReactNode} from 'react';
import {createPortal} from 'react-dom';

export const WorkspaceRailContext=createContext<HTMLElement|null>(null);

/** Route-owned filters share the shell rail without copying scope or identity controls. */
export function WorkspaceRailSlot({children}:{children:ReactNode}){
 const target=useContext(WorkspaceRailContext);
 return target?createPortal(children,target):null;
}
